"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[262],{

/***/ 1255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ block_content; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(8863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./components/photo.js
var photo = __webpack_require__(727);
// EXTERNAL MODULE: ./components/link.js + 1 modules
var components_link = __webpack_require__(8250);
;// CONCATENATED MODULE: ./components/block-serializers.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var blockSerializers = {
    types: {
        block: function(props) {
            var _node = props.node, markDefs = _node.markDefs, _style = _node.style, style = _style === void 0 ? "normal" : _style;
            // check if our block contains a button
            var hasButton = markDefs && markDefs.some(function(c) {
                return c._type === "link" && c.isButton === true;
            });
            // build our mock header styles
            if (style === "h1mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h1", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h2mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h2", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h3mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h4mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h4", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h5mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h5", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h6mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h6", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "large") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-lg-3-mobile", "md:text-lg-3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-large", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadSmall") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-small", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-large font-sansRegular", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "caption") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-caption", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            // go through our remaing, true header styles
            if (/^h\d/.test(style)) {
                return(/*#__PURE__*/ react.createElement(style, {
                    className: hasButton ? "has-btn" : null
                }, props.children));
            }
            // handle all other blocks with the default serializer
            return BlockContent_default().defaultSerializers.types.block(props);
        },
        photo: function(param) {
            var node = param.node;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                photo: node
            }));
        },
        horizontalRule: function() {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("hr", {});
        }
    },
    marks: {
        link: function(param) {
            var mark = param.mark, children = param.children;
            var title = children[0];
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* default */.Z, {
                link: _objectSpread({}, mark, {
                    title: title
                })
            }));
        }
    }
};

;// CONCATENATED MODULE: ./components/block-content.js





var Content = function(param) {
    var blocks = param.blocks, className = param.className;
    if (!blocks) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        renderContainerOnSingleChild: true,
        className: classnames_default()("rc", className),
        blocks: blocks,
        serializers: blockSerializers
    }));
};
/* harmony default export */ var block_content = (Content);


/***/ }),

/***/ 9634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(727);




var Media = function(param) {
    var media = param.media, layout = param.layout, _aspect = param.aspect, aspect = _aspect === void 0 ? false : _aspect;
    if (!media) return null;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("media-wrap", {
            "mx-auto": media.maxWidth
        }),
        style: {
            maxWidth: media.maxWidth ? media.maxWidth : "none"
        },
        children: media.photo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            photo: media.photo,
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("relative", {
                "aspect-video": aspect == "video",
                "aspect-square": aspect == "square"
            }),
            width: 2200,
            layout: layout
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Media);


/***/ }),

/***/ 1262:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ text_and_media; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/media.js
var components_media = __webpack_require__(9634);
// EXTERNAL MODULE: ./components/phrase.js
var components_phrase = __webpack_require__(1995);
// EXTERNAL MODULE: ./lib/helpers.js
var helpers = __webpack_require__(5722);
// EXTERNAL MODULE: ./components/icon.js
var icon = __webpack_require__(7627);
// EXTERNAL MODULE: ./components/block-content.js + 1 modules
var block_content = __webpack_require__(1255);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/popmotion/dist/es/utils/interpolate.mjs + 6 modules
var interpolate = __webpack_require__(645);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/transform.mjs



var isCustomValueType = function (v) {
    return typeof v === "object" && v.mix;
};
var getMixer = function (v) { return (isCustomValueType(v) ? v.mix : undefined); };
function transform() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var useImmediate = !Array.isArray(args[0]);
    var argOffset = useImmediate ? 0 : -1;
    var inputValue = args[0 + argOffset];
    var inputRange = args[1 + argOffset];
    var outputRange = args[2 + argOffset];
    var options = args[3 + argOffset];
    var interpolator = (0,interpolate/* interpolate */.s)(inputRange, outputRange, (0,tslib_es6/* __assign */.pi)({ mixer: getMixer(outputRange[0]) }, options));
    return useImmediate ? interpolator(inputValue) : interpolator;
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/index.mjs
var es_value = __webpack_require__(3234);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/context/MotionConfigContext.mjs
var MotionConfigContext = __webpack_require__(6014);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-constant.mjs
var use_constant = __webpack_require__(6681);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-motion-value.mjs






/**
 * Creates a `MotionValue` to track the state and velocity of a value.
 *
 * Usually, these are created automatically. For advanced use-cases, like use with `useTransform`, you can create `MotionValue`s externally and pass them into the animated component via the `style` prop.
 *
 * ```jsx
 * export const MyComponent = () => {
 *   const scale = useMotionValue(1)
 *
 *   return <motion.div style={{ scale }} />
 * }
 * ```
 *
 * @param initial - The initial state.
 *
 * @public
 */
function useMotionValue(initial) {
    var value = (0,use_constant/* useConstant */.h)(function () { return (0,es_value/* motionValue */.B)(initial); });
    /**
     * If this motion value is being used in static mode, like on
     * the Framer canvas, force components to rerender when the motion
     * value is updated.
     */
    var isStatic = (0,react.useContext)(MotionConfigContext/* MotionConfigContext */._).isStatic;
    if (isStatic) {
        var _a = (0,tslib_es6/* __read */.CR)((0,react.useState)(initial), 2), setLatest_1 = _a[1];
        (0,react.useEffect)(function () { return value.onChange(setLatest_1); }, []);
    }
    return value;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-on-change.mjs



function useOnChange(value, callback) {
    useEffect(function () {
        if (isMotionValue(value))
            return value.onChange(callback);
    }, [callback]);
}
function useMultiOnChange(values, handler) {
    (0,react.useEffect)(function () {
        var subscriptions = values.map(function (value) { return value.onChange(handler); });
        return function () { return subscriptions.forEach(function (unsubscribe) { return unsubscribe(); }); };
    });
}



// EXTERNAL MODULE: ./node_modules/framesync/dist/es/index.mjs + 2 modules
var es = __webpack_require__(4735);
;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-combine-values.mjs




function useCombineMotionValues(values, combineValues) {
    /**
     * Initialise the returned motion value. This remains the same between renders.
     */
    var value = useMotionValue(combineValues());
    /**
     * Create a function that will update the template motion value with the latest values.
     * This is pre-bound so whenever a motion value updates it can schedule its
     * execution in Framesync. If it's already been scheduled it won't be fired twice
     * in a single frame.
     */
    var updateValue = function () { return value.set(combineValues()); };
    /**
     * Synchronously update the motion value with the latest values during the render.
     * This ensures that within a React render, the styles applied to the DOM are up-to-date.
     */
    updateValue();
    /**
     * Subscribe to all motion values found within the template. Whenever any of them change,
     * schedule an update.
     */
    useMultiOnChange(values, function () { return es/* default.update */.ZP.update(updateValue, false, true); });
    return value;
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/value/use-transform.mjs





function useTransform(input, inputRangeOrTransformer, outputRange, options) {
    var transformer = typeof inputRangeOrTransformer === "function"
        ? inputRangeOrTransformer
        : transform(inputRangeOrTransformer, outputRange, options);
    return Array.isArray(input)
        ? useListTransform(input, transformer)
        : useListTransform([input], function (_a) {
            var _b = (0,tslib_es6/* __read */.CR)(_a, 1), latest = _b[0];
            return transformer(latest);
        });
}
function useListTransform(values, transformer) {
    var latest = (0,use_constant/* useConstant */.h)(function () { return []; });
    return useCombineMotionValues(values, function () {
        latest.length = 0;
        var numValues = values.length;
        for (var i = 0; i < numValues; i++) {
            latest[i] = values[i].get();
        }
        return transformer(latest);
    });
}



// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/value/scroll/use-viewport-scroll.mjs + 1 modules
var use_viewport_scroll = __webpack_require__(4087);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/animation/use-animation.mjs + 1 modules
var use_animation = __webpack_require__(6513);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 27 modules
var motion_minimal = __webpack_require__(6139);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.modern.mjs
var react_intersection_observer_modern = __webpack_require__(7650);
;// CONCATENATED MODULE: ./components/modules/text-and-media.js











function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var TextAndMedia = function(param) {
    var _data = param.data, data = _data === void 0 ? {} : _data;
    var style = data.style, sectionTitle = data.sectionTitle, body = data.body, media = data.media, phrase = data.phrase, includeScaleAnimation = data.includeScaleAnimation;
    var ref = (0,react.useState)(false), hideText = ref[0], setHideText = ref[1];
    var ref1 = (0,helpers/* useWindowSize */.iP)(), windowWidth = ref1.width;
    var componentRef = (0,react.useRef)(), ref2 = (0,helpers/* useRefScrollProgress */.Jd)(componentRef), start = ref2.start, end = ref2.end;
    var ref3 = (0,use_viewport_scroll/* useViewportScroll */.M)(), scrollY = ref3.scrollY, scrollYProgress = ref3.scrollYProgress;
    var scale = useTransform(scrollYProgress, [
        start,
        end
    ], [
        1,
        windowWidth > 768 ? 1.81818182 : 1
    ]), opacity = useTransform(scrollYProgress, [
        start,
        end
    ], [
        1,
        windowWidth > 768 ? 0 : 1
    ]);
    (0,react.useEffect)(function() {
        return opacity.onChange(function(latest) {
            if (includeScaleAnimation) {
                if (latest < 1) {
                    setHideText(true);
                } else {
                    setHideText(false);
                }
            }
        });
    }, [
        opacity,
        hideText,
        includeScaleAnimation,
        scrollYProgress
    ]);
    var horizontalLineVariants = {
        visible: {
            opacity: 1,
            maxWidth: "600px",
            transition: {
                duration: 2,
                ease: "easeInOut"
            }
        },
        hidden: {
            opacity: 0,
            maxWidth: 0
        }
    };
    var controls = (0,use_animation/* useAnimation */._)();
    var ref4 = _slicedToArray((0,react_intersection_observer_modern/* useInView */.YD)(), 2), ref5 = ref4[0], inView = ref4[1];
    (0,react.useEffect)(function() {
        if (inView) {
            controls.start("visible");
        }
    }, [
        controls,
        inView
    ]);
    if (style == "atAGlance") {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: classnames_default()("text-and-media"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("grid", "grid-cols-4", "md:grid-cols-20", "place-content-center", "text-center", "px-gutter", "py-gutter", "md:py-[60px]", "site-container-xl"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("col-span-4", "md:col-span-18", "md:col-start-2"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                            media: media,
                            layout: "fill",
                            aspect: "video"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("col-span-4", "md:col-span-18", "md:col-start-2", "p-5", "bg-white", "rounded-b-[3px]", "border-t-yellow", "border-t-[5px]", "flex", "flex-col", "md:flex-row"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("hidden", "sm:block", "w-full"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_phrase/* default */.Z, {
                                    phrase: phrase,
                                    dividerMaxWidth: "5%",
                                    typeStyle: "text-subheader-2 whitespace-nowrap uppercase font-sansRegular"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("flex", "sm:hidden"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_phrase/* default */.Z, {
                                    phrase: phrase,
                                    vertical: true,
                                    hideLast: true,
                                    dividerMaxWidth: "50px",
                                    typeStyle: "text-subheader-2 uppercase font-sansRegular",
                                    wordStyle: "inline-block mt-[4px] mb-[4px]"
                                })
                            })
                        ]
                    })
                ]
            })
        }));
    }
    if (style == "fullWidth") {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: classnames_default()("text-and-media", "mt-[100px]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("grid", "grid-cols-1", "p-gutter", "site-container-xl"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("col-span-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: classnames_default()("text-lg-2-mobile", "md:text-lg-2"),
                            children: sectionTitle
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("col-span-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                            media: media,
                            layout: "intrinsic"
                        })
                    })
                ]
            })
        }));
    }
    if (style == "fullWidthTextBelow") {
        return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: classnames_default()("text-and-media"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()("grid", "grid-cols-1", "p-gutter", "site-container-xl"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("col-span-1"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                            media: media,
                            layout: "fill",
                            aspect: "video"
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("grid", "grid-cols-4", "sm:grid-cols-20", "gap-gutter", "p-gutter", "site-container-xl"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("col-span-4", "sm:col-span-9"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("text-subheader-2", "uppercase", "flex", "flex-col", "sm:flex-row", "items-center", "mt-3"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: classnames_default()("whitespace-nowrap", "sm:mr-5", "text-center", "w-full", "block", "sm:w-auto", "sm:text-left", "font-sansRegular"),
                                        children: sectionTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                                        ref: ref5,
                                        animate: controls,
                                        initial: "hidden",
                                        variants: horizontalLineVariants,
                                        className: classnames_default()("divider", "h-[120px]", "w-[1px]", "mt-2", "sm:mt-0", "sm:w-[1000px]", "sm:h-[1px]", "flex"),
                                        style: {
                                            backgroundColor: "#000000"
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("col-span-4", "sm:col-span-11", "text-lg-2-mobile", "md:text-lg-2", "text-left"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(block_content/* default */.Z, {
                                blocks: body
                            })
                        })
                    ]
                })
            ]
        }));
    }
    if (includeScaleAnimation) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: classnames_default()("text-and-media", "sm:h-[180vh]"),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()("card", "m-2", "flex", "flex-column", "h-full"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: classnames_default()("grid", "p-1", "grid-cols-1", "sm:grid-cols-20", "w-full", "rounded-[3px]", "sticky", "bottom-[56px]", "mt-auto", "site-container-xl", "transition-background", "duration-500", {
                        "bg-white": !hideText,
                        "bg-transparent": hideText
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(motion_minimal.m.div, {
                            className: classnames_default()("col-span-9", "flex", "flex-col", "p-2", "transition-opacity", "duration-500", {
                                "opacity-100": !hideText,
                                "opacity-0": hideText
                            }),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("text-subheader", "font-sansRegular", "mb-10", "md:mb-0", "uppercase"),
                                    children: sectionTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classnames_default()("mt-auto", "text-caption", "font-sansRegular", "max-w-[300px]", "mb-2", "md:mb-0"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: classnames_default()("border-t", "w-[50px]", "mb-2")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(block_content/* default */.Z, {
                                            blocks: body
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(motion_minimal.m.div, {
                            className: classnames_default()("col-span-11", "origin-bottom-right"),
                            ref: componentRef,
                            style: {
                                scale: scale
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                                media: media,
                                layout: "intrinsic"
                            })
                        })
                    ]
                })
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()("text-and-media"),
        ref: componentRef,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classnames_default()("card", "m-2", {
                "sm:h-[100vh] flex flex-column": includeScaleAnimation
            }),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()("grid", "p-1", "grid-cols-1", "sm:grid-cols-20", "bg-white", "w-full", "rounded-[3px]", "site-container-xl"),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()("col-span-9", "flex", "flex-col", "p-2"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("text-subheader", "font-sansRegular", "mb-10", "md:mb-0", "uppercase"),
                                children: sectionTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("mt-auto", "text-caption", "font-sansRegular", "max-w-[300px]", "mb-2", "md:mb-0"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("border-t", "w-[50px]", "mb-2")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(block_content/* default */.Z, {
                                        blocks: body
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classnames_default()("col-span-11"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_media/* default */.Z, {
                            media: media,
                            layout: "intrinsic"
                        })
                    })
                ]
            })
        })
    }));
};
/* harmony default export */ var text_and_media = (TextAndMedia);


/***/ }),

/***/ 7650:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);


function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const observerMap = new Map();
const RootIds = new WeakMap();
let rootId = 0;
let unsupportedValue = undefined;
/**
 * What should be the default behavior if the IntersectionObserver is unsupported?
 * Ideally the polyfill has been loaded, you can have the following happen:
 * - `undefined`: Throw an error
 * - `true` or `false`: Set the `inView` value to this regardless of intersection state
 * **/

function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
/**
 * Generate a unique ID for the root element
 * @param root
 */

function getRootId(root) {
  if (!root) return '0';
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
/**
 * Convert the options to a string Id, based on the values.
 * Ensures we can reuse the same observer when observing elements with the same options.
 * @param options
 */


function optionsToId(options) {
  return Object.keys(options).sort().filter(key => options[key] !== undefined).map(key => {
    return `${key}_${key === 'root' ? getRootId(options.root) : options[key]}`;
  }).toString();
}

function createObserver(options) {
  // Create a unique ID for this observer instance, based on the root, root margin and threshold.
  let id = optionsToId(options);
  let instance = observerMap.get(id);

  if (!instance) {
    // Create a map of elements this observer is going to observe. Each element has a list of callbacks that should be triggered, once it comes into view.
    const elements = new Map();
    let thresholds;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        var _elements$get;

        // While it would be nice if you could just look at isIntersecting to determine if the component is inside the viewport, browsers can't agree on how to use it.
        // -Firefox ignores `threshold` when considering `isIntersecting`, so it will never be false again if `threshold` is > 0
        const inView = entry.isIntersecting && thresholds.some(threshold => entry.intersectionRatio >= threshold); // @ts-ignore support IntersectionObserver v2

        if (options.trackVisibility && typeof entry.isVisible === 'undefined') {
          // The browser doesn't support Intersection Observer v2, falling back to v1 behavior.
          // @ts-ignore
          entry.isVisible = inView;
        }

        (_elements$get = elements.get(entry.target)) == null ? void 0 : _elements$get.forEach(callback => {
          callback(inView, entry);
        });
      });
    }, options); // Ensure we have a valid thresholds array. If not, use the threshold from the options

    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }

  return instance;
}
/**
 * @param element - DOM Element to observe
 * @param callback - Callback function to trigger when intersection status changes
 * @param options - Intersection Observer options
 * @param fallbackInView - Fallback inView value.
 * @return Function - Cleanup function that should be triggered to unregister the observer
 */


function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === 'undefined' && fallbackInView !== undefined) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === 'number' ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {// Nothing to cleanup
    };
  } // An observer with the same options can be reused, so lets use this fact


  const {
    id,
    observer,
    elements
  } = createObserver(options); // Register the callback listener for this element

  let callbacks = elements.get(element) || [];

  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }

  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    // Remove the callback from the callback list
    callbacks.splice(callbacks.indexOf(callback), 1);

    if (callbacks.length === 0) {
      // No more callback exists for element, so destroy it
      elements.delete(element);
      observer.unobserve(element);
    }

    if (elements.size === 0) {
      // No more elements are being observer by this instance, so destroy it
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

const _excluded = (/* unused pure expression or super */ null && (["children", "as", "triggerOnce", "threshold", "root", "rootMargin", "onChange", "skip", "trackVisibility", "delay", "initialInView", "fallbackInView"]));

function isPlainChildren(props) {
  return typeof props.children !== 'function';
}
/**
 ## Render props

 To use the `<InView>` component, you pass it a function. It will be called
 whenever the state changes, with the new value of `inView`. In addition to the
 `inView` prop, children also receive a `ref` that should be set on the
 containing DOM element. This is the element that the IntersectionObserver will
 monitor.

 If you need it, you can also access the
 [`IntersectionObserverEntry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry)
 on `entry`, giving you access to all the details about the current intersection
 state.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView>
 {({ inView, ref, entry }) => (
      <div ref={ref}>
        <h2>{`Header inside viewport ${inView}.`}</h2>
      </div>
    )}
 </InView>
 );

 export default Component;
 ```

 ## Plain children

 You can pass any element to the `<InView />`, and it will handle creating the
 wrapping DOM element. Add a handler to the `onChange` method, and control the
 state in your own component. Any extra props you add to `<InView>` will be
 passed to the HTML element, allowing you set the `className`, `style`, etc.

 ```jsx
 import { InView } from 'react-intersection-observer';

 const Component = () => (
 <InView as="div" onChange={(inView, entry) => console.log('Inview:', inView)}>
 <h2>Plain children are always rendered. Use onChange to monitor state.</h2>
 </InView>
 );

 export default Component;
 ```
 */


class InView extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    this.node = null;
    this._unobserveCb = null;

    this.handleNode = node => {
      if (this.node) {
        // Clear the old observer, before we start observing a new element
        this.unobserve();

        if (!node && !this.props.triggerOnce && !this.props.skip) {
          // Reset the state if we get a new node, and we aren't ignoring updates
          this.setState({
            inView: !!this.props.initialInView,
            entry: undefined
          });
        }
      }

      this.node = node ? node : null;
      this.observeNode();
    };

    this.handleChange = (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        // If `triggerOnce` is true, we should stop observing the element.
        this.unobserve();
      }

      if (!isPlainChildren(this.props)) {
        // Store the current State, so we can pass it to the children in the next render update
        // There's no reason to update the state for plain children, since it's not used in the rendering.
        this.setState({
          inView,
          entry
        });
      }

      if (this.props.onChange) {
        // If the user is actively listening for onChange, always trigger it
        this.props.onChange(inView, entry);
      }
    };

    this.state = {
      inView: !!props.initialInView,
      entry: undefined
    };
  }

  componentDidUpdate(prevProps) {
    // If a IntersectionObserver option changed, reinit the observer
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }

  componentWillUnmount() {
    this.unobserve();
    this.node = null;
  }

  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(this.node, this.handleChange, {
      threshold,
      root,
      rootMargin,
      // @ts-ignore
      trackVisibility,
      // @ts-ignore
      delay
    }, fallbackInView);
  }

  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();

      this._unobserveCb = null;
    }
  }

  render() {
    if (!isPlainChildren(this.props)) {
      const {
        inView,
        entry
      } = this.state;
      return this.props.children({
        inView,
        entry,
        ref: this.handleNode
      });
    }

    const _this$props = this.props,
          {
      children,
      as
    } = _this$props,
          props = _objectWithoutPropertiesLoose(_this$props, _excluded);

    return React.createElement(as || 'div', _extends({
      ref: this.handleNode
    }, props), children);
  }

}

/**
 * React Hooks make it easy to monitor the `inView` state of your components. Call
 * the `useInView` hook with the (optional) [options](#options) you need. It will
 * return an array containing a `ref`, the `inView` status and the current
 * [`entry`](https://developer.mozilla.org/en-US/docs/Web/API/IntersectionObserverEntry).
 * Assign the `ref` to the DOM element you want to monitor, and the hook will
 * report the status.
 *
 * @example
 * ```jsx
 * import React from 'react';
 * import { useInView } from 'react-intersection-observer';
 *
 * const Component = () => {
 *   const { ref, inView, entry } = useInView({
 *       threshold: 0,
 *   });
 *
 *   return (
 *     <div ref={ref}>
 *       <h2>{`Header inside viewport ${inView}.`}</h2>
 *     </div>
 *   );
 * };
 * ```
 */

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  const unobserve = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView
  }); // Store the onChange callback in a `ref`, so we can access the latest instance inside the `useCallback`.

  callback.current = onChange;
  const setRef = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(node => {
    if (unobserve.current !== undefined) {
      unobserve.current();
      unobserve.current = undefined;
    } // Skip creating the observer


    if (skip) return;

    if (node) {
      unobserve.current = observe(node, (inView, entry) => {
        setState({
          inView,
          entry
        });
        if (callback.current) callback.current(inView, entry);

        if (entry.isIntersecting && triggerOnce && unobserve.current) {
          // If it should only trigger once, unobserve the element after it's inView
          unobserve.current();
          unobserve.current = undefined;
        }
      }, {
        root,
        rootMargin,
        threshold,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      }, fallbackInView);
    }
  }, // We break the rule here, because we aren't including the actual `threshold` variable
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [// If the threshold is an array, convert it to a string so it won't change between renders.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  Array.isArray(threshold) ? threshold.toString() : threshold, root, rootMargin, triggerOnce, skip, trackVisibility, fallbackInView, delay]);
  /* eslint-disable-next-line */

  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    if (!unobserve.current && state.entry && !triggerOnce && !skip) {
      // If we don't have a ref, then reset the state (unless the hook is set to only `triggerOnce` or `skip`)
      // This ensures we correctly reflect the current state - If you aren't observing anything, then nothing is inView
      setState({
        inView: !!initialInView
      });
    }
  });
  const result = [setRef, state.inView, state.entry]; // Support object destructuring, by adding the specific values.

  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}


//# sourceMappingURL=react-intersection-observer.modern.mjs.map


/***/ })

}]);